module.exports = __webpack_public_path__ + "static/media/dodging.3c689d6d.svg";